import { Dto } from '@mango/core';
import { Instrument } from './instrument';


@Dto({fullName: "CIJBorculo.Logic.InstrumentRelatie"})
export class instrumentRelatie {
    instrumenten?: Instrument[];    
    relatie: number;
}
